import React from 'react';
import { Backdrop, CircularProgress, Box } from '@mui/material';
import { useLoading } from '../context/LoadingContext';

// Component to show loading Page
function GlobalLoading() {
  const { loading } = useLoading();

  return (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: 9999,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
      }}
      open={loading}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <CircularProgress
          color="primary"
          size={60}
          thickness={4}
          sx={{
            color: '#fff',
          }}
        />
        <Box
          sx={{
            color: '#fff',
            fontSize: '1rem',
            fontWeight: 500,
          }}
        >
          Loading...
        </Box>
      </Box>
    </Backdrop>
  );
}

export default GlobalLoading;
